const state = {
  current: {
    key: null,
    icon: null,
    text: '閉じる'
  },
  items: [{
    key: 'characters',
    icon: 'user-circle',
    text: 'キャラクター作成',
    permission: 5
  }, {
    key: 'scenes',
      icon: 'image',
      text: 'シーン作成(KP)',
      permission: 10
    }, {
      key: 'items',
      icon: 'sticky-note',
      text: '共有メモ作成(KP)',
      permission: 10
    }, {
      key: 'setting',
      icon: 'wrench',
      text: '設定・ヘルプ',
      permission: 0
    }]
}

const mutations = {
  set(state, { key, icon }) {
    state.current.key = key
    state.current.icon = icon
  },
  remove(state) {
    state.current.key = null
    state.current.icon = null
  }
}

const getters = {
  items(state) {
    return state.items
  },
  current(state) {
    return state.current
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}